import React, { useContext, useEffect, useState } from "react";
import { createGlobalStyle } from "styled-components";
import { Link } from "gatsby";

import { AuthContext } from "../../context/auth";
import api from "../../services/api";
import { bravoRequest } from "../../services";

const GlobalStyle = createGlobalStyle`
  .header-modal {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    margin-bottom: 30px;

    .author-perfil {
      display: flex;
      align-items: center;

      span {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        margin-right: 10px;
        display: inline-block;
        background-size: cover;
        background-position: center;
      }

      .author-name {
        h4 {
          font: italic bold 14px 'Times new roman';
          color: #323232;
          margin-bottom: 14px;
        }

        a {
          text-transform: uppercase;
          font-size: 11px;
          color: #959595;

          display: flex;
          align-items: center;

          i {
            background: url("/images/arrow-right-bold.png") no-repeat center;
            background-size: contain;
            width: 17px;
            height: 12px;
            margin-right: 6px;
          }

          span{
            width: 80px;
            height: 18px;
          }
        }
      }
    }

    .header-actions {

      .btn-likes {
        cursor: pointer;
        margin-top: 16px;
        margin-left: auto;
        height: 36px;
        border: 2px solid #f1a857;
        border-radius: 3px;
        background: #ffffff;

        display: flex;
        align-items: center;

        transition: .2s all ease;

        &.disabled {
          cursor :none;
          position: relative;

          div {
            display: none;
          }

          &:hover {
            div {
              position: absolute;
              top: 50px;
              background: #f1a857;
              padding: 4px 12px;
              color: #fff;
              display: block;
            }
          }
        }

        span {
          font-size: 12px;
          color: #6a6a6a;
          min-width: 50px;
        }

        i {
          background: url('/images/heart.svg') no-repeat center;
          background-size: contain;
          width: 37px;
          height: 100%;
          background-size: 16px;
          border-right: 1px solid #f1a857;
        }

        &:hover,
        &.liked {
          background: #f1a857;

          span {
            color: #ffffff;
          }

          i {
            border-right: 1px solid #e0933d;
          }
        }
      }

      .close-modal {
        margin-left: auto;
        background: #f1a857;
        height: 34px;
        width: 53px;
        border-radius: 3px;

        display: flex;
        align-items: center;
        justify-content: center;

        transition: .2s all ease;

        i {
          background: url("/images/streamline-icon-close-140-x-140.png") no-repeat center;
          background-size: contain;
          width: 17px;
          height: 17px;
        }

        &:hover {
          background: #e59134;
        }
      }
    }

    @media (min-width: 767px) {
      align-items: center;
      margin-bottom: 40px;

      .author-perfil {

        img {
          margin-right: 27px;
        }

        .author-name {
          h4 {
            font: italic bold 20px 'Times new roman';
            margin-bottom: 12px;
          }

          a {
            font-size: 12px;
          }
        }
      }
      .header-actions {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;

        .btn-likes {
          margin-top: 0;
          height: 50px;

          span {
            font-size: 16px;
            min-width: 110px;
            font-weight: 600;
          }

          i {
            width: 70px;
            background-size: 24px;
          }
        }

        .close-modal {
          margin-left: 16px;
          height: 50px;
          width: 83px;

          i {
            width: 24px;
            height: 24px;
          }
        }
      }
    }
  }
`;

export default function HeaderModal({
  modal,
  closeTo,
  projectId,
  likes,
  name,
  email,
  image,
  profileId,
  modalCloseCallBack,
}) {
  const [numLikes, setNum] = useState(likes);
  const { user, isLoggedIn } = useContext(AuthContext);
  const [liked, setLiked] = useState(false);
  const [anonLiked, setAnonLiked] = useState(false);

  async function checkLike() {
    const localLikes = parseInt(
      localStorage.getItem(`project_${projectId}_anon_likes`) || "0",
      10
    );

    setNum((prevNumLikes) => prevNumLikes + localLikes); // Utiliza o valor anterior

    if (localLikes > 0 && !isLoggedIn) {
      setAnonLiked(true);
      return;
    }

    if (user && user.id) {
      const response = await api.get(
        `https://apimeuambiente.guararapes.com.br/project/${projectId}/user/${user.id}/like/check/`
      );
      setLiked(response.data.status);
    }
  }

  useEffect(() => {
    checkLike();
  }, [user, projectId]);

  async function handleFavorite() {
    const anonLikedLocal = parseInt(
      localStorage.getItem(`project_${projectId}_anon_likes`) || "0",
      10
    );

    if (anonLikedLocal > 0) {
      setLiked(false); // Reseta o estado de "liked" se estiver vindo do localStorage
    }

    if (liked) return; // Não faz nada se já tiver dado like

    try {
      if (!user || !user.id) {
        setAnonLiked(true);
        setNum(numLikes + 1);
        localStorage.setItem(`project_${projectId}_anon_likes`, numLikes + 1);

        await bravoRequest({
          email: email,
          type: "IN",
          description:
            "Pontuacao gerada por projeto favoritado (usuario nao logado)",
          external_id: `mag_${projectId}_${user?.id ?? ""}`,
          points: 5,
          coins: 5,
        });

        return;
      }

      await api.post(
        `https://apimeuambiente.guararapes.com.br/project/${projectId}/user/${user.id}/create/`
      );

      await Promise.all([
        bravoRequest({
          email: user.email,
          type: "IN",
          description: "Pontuacao gerada por projeto favoritado",
          external_id: `mag_${projectId}_${user.id}`,
          points: 5,
          coins: 5,
        }),
        user &&
          bravoRequest({
            email: email,
            type: "IN",
            description:
              "Pontuacao gerada por projeto favoritado e para usuario logado",
            external_id: `mag_${projectId}_${user.id}`,
            points: 5,
            coins: 5,
          }),
      ]);

      setNum(numLikes + 1);
      setLiked(true);
    } catch (error) {
      console.error("Erro ao processar o favoritar:", error);
    }
  }

  async function handleRemoveFavorite() {
    try {
      if (!user || !user.id) {
        setAnonLiked(false);

        setNum(numLikes - 1);
        Math.max(numLikes - 1, 0);

        localStorage.removeItem(`project_${projectId}_anon_likes`);

        await bravoRequest({
          email: email,
          type: "OUT",
          description:
            "Pontuacao removida por projeto desfavoritado (usuario nao logado)",
          external_id: `mag_${projectId}_${user?.id ?? ""}`,
          points: 5,
          coins: 5,
        });
        return;
      }

      await api.post(
        `https://apimeuambiente.guararapes.com.br/project/${projectId}/user/${user.id}/remove/`
      );
      await Promise.all([
        bravoRequest({
          email: user.email,
          type: "OUT",
          description: "Pontuacao removida por projeto desfavoritado",
          external_id: `mag_${projectId}_${user.id}`,
          points: 5,
          coins: 5,
        }),
        !user &&
          bravoRequest({
            email: email,
            type: "OUT",
            description:
              "Pontuacao removida do projeto desfavoritado e do usuario logado",
            external_id: `mag_${projectId}_${user.id}`,
            points: 5,
            coins: 5,
          }),
      ]);
      numLikes < 0 ? setNum(0) : setNum(numLikes - 1);
      setLiked(false);
    } catch (error) {
      console.error("Erro ao processar o desfavoritar:", error);
    }
  }

  return (
    <>
      <div className="header-modal">
        <div className="author-perfil">
          <span style={{ backgroundImage: `url(${image})` }}></span>
          <div className="author-name">
            <h4>{name}</h4>
            <Link to={`/perfil/${profileId}`}>
              <i></i>
              <span>ver perfil</span>
            </Link>
          </div>
        </div>

        <div className="header-actions">
          {modalCloseCallBack && (
            <span
              className="close-modal"
              style={{ cursor: "pointer" }}
              onClick={() => {
                modalCloseCallBack(false);
              }}
            >
              <i></i>
            </span>
          )}
          {modal && (
            <Link to={closeTo} className="close-modal">
              <i></i>
            </Link>
          )}
          {/* {isLoggedIn ? ( */}
          <>
            {liked || anonLiked ? (
              <button
                className="btn-likes liked"
                onClick={handleRemoveFavorite}
              >
                <i></i>
                <span>{numLikes}</span>
              </button>
            ) : (
              <button className="btn-likes" onClick={handleFavorite}>
                <i></i>
                <span>{numLikes}</span>
              </button>
            )}
          </>
          {/* ) : (
            <button className="btn-likes disabled">
              <i></i>
              <span>{numLikes}</span>
              <div>Você precisa estar logado para dar like.</div>
            </button>
          )} */}
        </div>
      </div>

      <GlobalStyle />
    </>
  );
}
